import { render, staticRenderFns } from "./NewsArticles.vue?vue&type=template&id=c2f0ec3e&"
import script from "./NewsArticles.vue?vue&type=script&lang=js&"
export * from "./NewsArticles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports